import React, {useState, useEffect} from 'react'
import {DatePicker, Select, Spin, Alert} from 'antd'
import InputSearch from "./filters/InputSearch"
import SelectSearch from "./filters/SelectSearch"
import {getListSku, getSkuSizesShippingCarrier} from "../../../services/api/apiSku"
import {getActionKeys} from "../../../services/api/apiOrdersReport"
import { getUserList } from '../../../services/api/UserService'
import moment from "moment"
import {
    SearchOutlined,
} from '@ant-design/icons'

const {RangePicker} = DatePicker
const {Option} = Select

function UsersStaticsDetaileFilters(props) {
    const {filters, setState, selectedDate, onChangeSelectedDate} = props
    const [skus, setSkus] = useState([{value: '', name: 'Chọn Sku'}])
    const [sizes, setSizes] = useState([{value: '', name: 'Chọn Size'}])
    const [loadingSku, setLoadingSku] = useState(false)
    const [loadingSize, setLoadingSize] = useState(false)
    const [loadingUser, setLoadingUser] = useState(false)
    const [listUser, setListUser] = useState([])
    const [error, setError] = useState('')
    const [actionOptions, setActionOptions] = useState([])

    const _fetchListSkus = async () => {
        setSkus([])
        setLoadingSku(true)
        try {
            const payload = {
                sort: 'name',
                limit: 10000,
                page: 1,
            }

            const {'data': responsive} = await getListSku(payload)

            const {success, data} = responsive

            if (!success) return setLoadingSku(false)

            const skus = data.items.map(item => {
                return {
                    value: item.sku,
                    name: item.name,
                    id: item._id
                }
            })
            setSkus([{value: '', name: 'Chọn Sku'}, ...skus])
        } catch (e) {
            console.log(e.message)
        }
        setLoadingSku(false)
    }

    const _fetchListSizes = async (sku) => {

        const skuSelected = skus.find(item => item.value === sku)
        if (skuSelected !== undefined) {
            setLoadingSize(true)
            setSizes([])
            try {
                const payload = {
                    shipping_carrier: 'default'
                }

                const {data: respon} = await getSkuSizesShippingCarrier(skuSelected.id, payload)
                const {success, data} = respon

                if (!success) return setLoadingSize(false)

                const _sizes = data.map(item => {
                    return {
                        value: item._id,
                        name: item.sku
                    }
                })

                setSizes([{value: '', name: 'Chọn Size'}, ..._sizes])
            } catch (e) {
                console.log(e.message)
            }
            setLoadingSize(false)
        }
    }

    const fetchActionKeys = async () => {
        try {
            const {data: response} = await getActionKeys()
            const {success, data} = response

            if (!success) return

            const options = data.actions.map(item => ({value: item.key, name: item.label}))
            setActionOptions(options)
        } catch (e) {
            console.log(e.message)
        }
    }

    const fetchUser = async() => {
        setError('')
        setLoadingUser(true)
        try {
            const { data, message, success } = await getUserList({ page: 1, limit: 10000, })
            if (!success) {
                console.log(message)
                setError(message)
                return setLoadingUser(false)
            } else {
                setListUser(data.users)
            }
        } catch (error) {
            console.log(error)
            setError(error.message)
        } finally {
            setLoadingUser(false)
        }
    }

    useEffect(() => {
        _fetchListSkus()
        fetchUser()
        fetchActionKeys()
    }, [])

    const _onDateChange = (dates) => {
        if (!!dates && dates.length === 2) {
            if (typeof setState === 'function') {
                setState({
                    ...filters,
                    time_from: moment(dates[0]).format('HH:mm'),
                    time_to: moment(dates[1]).format('HH:mm'),
                    date_from: moment(dates[0]).format('DD/MM/YYYY'),
                    date_to: moment(dates[1]).format('DD/MM/YYYY')
                })
            }

            if (typeof onChangeSelectedDate === 'function') {
                onChangeSelectedDate(dates)
            }
        } else {
            const _filters = Object.assign({}, filters)
            delete _filters['time_from']
            delete _filters['time_to']
            delete _filters['date_from']
            delete _filters['date_to']
            if (typeof setState === 'function') {
                setState(_filters)
            }
            if (typeof onChangeSelectedDate === 'function') {
                onChangeSelectedDate([])
            }
        }
    }

    const _handleChange = (name, value) => {
        const _filters = {
            ...filters,
            [name]: value
        }
        setState(_filters)
    }

    const _handleChangeSelect = (name, value) => {
        let newValue = value

        if (name === 'size') {
            const sizeSelected = sizes.find(item => item.value === value)

            if (sizeSelected !== undefined) {
                if (sizeSelected.value !== '') {
                    newValue = sizeSelected.name
                } else {
                    newValue = ''
                }
            } else {
                newValue = ''
            }
        }

        setState({
            ...filters,
            size: name === 'sku' ? '' : filters.size,
            [name]: newValue,
        })

        if (name === 'sku') {
            _fetchListSizes(value)
        }
    }
    const userOptions = !!listUser.length && listUser.map((i, index) => ({ name: i.username, value: i.username }))

    return (
        <div className="mb-3 mt-3 Filters">
            <div className="row mb-3">
                <div className="SearchName col-3">
                    <div className="InputSearch">
                        <div className="font-weight-500 LabelFilter mb-1">Nhân viên:</div>
                        {error ? <Alert message={error} type={'error'} /> :
                            <Spin spinning={loadingUser}>
                                <Select
                                    name={'user'}
                                    value={filters.user || []}
                                    placeholder='Enter to search...'
                                    onChange={(value) => _handleChange('user', value)}
                                    style={{ width: "100%" }}
                                    mode='multiple'
                                    allowClear
                                >
                                    {!!userOptions && userOptions.length &&
                                        userOptions.map(item => {
                                            return <Option value={item.value} key={item.value}>{item.name}</Option>
                                        })
                                    }
                                </Select>
                                {filters.user.length === 0 &&
                                    <span className="icon">
                                        <SearchOutlined />
                                    </span>
                                }
                            </Spin>
                        }
                    </div>
                    {/* <InputSearch name="user" onChange={_handleChange} label="Nhân viên:" value={filters.user || []}/> */}
                </div>
                <div className="SearchBarcode col-3">
                    <InputSearch name="barcode" onChange={_handleChange} label="Barcode:"
                                 value={filters.barcode || []}/>
                </div>
                <div className="SearchBatch col-3">
                    <InputSearch name="batch" onChange={_handleChange} label="Lô:" value={filters.batch || []}/>
                </div>
                <div className="SearchBox col-3">
                    <InputSearch name="box" onChange={_handleChange} label="Số thùng:" value={filters.box || []}/>
                </div>
            </div>
            <div className="row mb-3">
                <div className="FilterActions col-3">
                    <SelectSearch
                        name="action"
                        mode="multiple"
                        label="Actions:"
                        clear={true}
                        listSelect={actionOptions}
                        value={filters.action || []}
                        onChange={_handleChangeSelect}
                        placeholder="Chọn action"
                    />
                </div>
                <div className="FilterSkus col-3">
                    <SelectSearch
                        name="sku"
                        mode="multiple"
                        label="Sku:" 
                        clear={true} 
                        listSelect={skus}
                        value={filters.sku || []}
                        disable={loadingSku}
                        loading={loadingSku}
                        onChange={_handleChangeSelect}
                        placeholder="Chọn Sku"
                    />
                </div>
                <div className="FilterSize col-3">
                    <SelectSearch disable={loadingSize} loading={loadingSize} name="size" value={filters.size || ''}
                                  onChange={_handleChangeSelect} label="Size:" listSelect={sizes}/>
                </div>
                <div className="SearchDateTime col-3">
                    <label className="font-weight-500 LabelFilter mb-1">Thời gian</label>
                    <div className='DatePicker'>
                        <RangePicker
                            value={selectedDate}
                            showTime={{format: 'HH:mm'}}
                            format="HH:mm - DD/MM/YYYY"
                            onChange={_onDateChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UsersStaticsDetaileFilters
